import type { Maybe } from '@tectonics/utils/types';
import type { Amount } from '@tectonics/prs/money';
import type { Receipt } from '../types';
import { CheckoutReceiptGetter } from '../types';

export const getAmountExt: CheckoutReceiptGetter<Amount> = ({ main }) => main?.amount_ext;

export const getAmountLocalBase: CheckoutReceiptGetter<Amount> = ({ main }) => main.amount_local_base;

export const getAmountLocal: CheckoutReceiptGetter<Amount> = ({ main }) => main.amount_local_total;

export const getCryptocurrencyReceipt: CheckoutReceiptGetter<Maybe<Receipt>> = ({ cryptocurrency }) => cryptocurrency;
